/**
 * Free quote form, built inside the Elementor box with the class quote-form.
 * Words come from paragraphs in that box: form-button, form-thanks.
 * Car photos: up to six, from the camera (touch screens) or the library, shrunk to 1600px JPEG
 * in the browser and sent with the form as multipart data.
 * Required fields carry a star and are checked before sending; each wrong one is marked in red with
 * its own message.
 *
 * @package Relax_Detail
 */

( function () {
	'use strict';

	var box = document.querySelector( '.quote-form' );
	var Q = window.rdQuote;
	if ( ! box || ! Q ) {
		return;
	}

	function text( cls, fallback ) {
		var p = box.querySelector( '.' + cls );
		return p ? p.innerHTML.trim() : fallback;
	}

	var button = box.querySelector( '.form-button' ) ? box.querySelector( '.form-button' ).textContent.trim() : 'Send my quote request';
	var thanks = text( 'form-thanks', 'Thanks. We will text you a quote within one business day.' );

	function options( list ) {
		return '<option value="">Choose</option>' + list.map( function ( v ) { var o = document.createElement( 'option' ); o.textContent = v; return o.outerHTML; } ).join( '' );
	}

	var MAX_PHOTOS = 6;
	var EDGE = 1600;
	var touch = window.matchMedia && window.matchMedia( '(pointer: coarse)' ).matches;

	// The message under each checked field when it is wrong, or '' when it is fine. Fields with a check
	// other than email are required and get the star.
	var CHECKS = {
		name: function ( v ) { return v ? '' : 'Please enter your name.'; },
		phone: function ( v ) { var n = v.replace( /\D/g, '' ).length; return n >= 10 && n <= 15 ? '' : 'Please enter a phone number we can text.'; },
		email: function ( v ) { return ! v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test( v ) ? '' : 'Please check your email address.'; },
		town: function ( v ) { return v ? '' : 'Please choose your town.'; },
		vehicle: function ( v ) { return v ? '' : 'Please enter the make and model.'; },
		size: function ( v ) { return v ? '' : 'Please choose a size.'; },
		service: function ( v ) { return v ? '' : 'Please choose a service.'; },
	};

	// A label row, the control, then the line its error shows on.
	function field( label, control, cls ) {
		var name = control.match( /name="([^"]+)"/ )[ 1 ];
		var req = CHECKS[ name ] && 'email' !== name;
		var attrs = CHECKS[ name ] ? ' aria-describedby="q-' + name + '-e"' + ( req ? ' required' : '' ) : '';
		return '<label' + ( cls ? ' class="' + cls + '"' : '' ) + '><span class="lbl">' + label +
			( req ? ' <span class="req" aria-hidden="true">*</span>' : '' ) + '</span>' +
			control.replace( /^<(\w+)/, '<$1' + attrs ) +
			( CHECKS[ name ] ? '<span class="field-err" id="q-' + name + '-e"></span>' : '' ) + '</label>';
	}

	var form = document.createElement( 'form' );
	form.noValidate = true;
	form.innerHTML =
		field( 'Name', '<input name="name" autocomplete="name">' ) +
		field( 'Phone', '<input name="phone" type="tel" autocomplete="tel" inputmode="tel">' ) +
		field( 'Email', '<input name="email" type="email" autocomplete="email">' ) +
		field( 'Town', '<select name="town">' + options( Q.towns ) + '</select>' ) +
		field( 'Vehicle make and model', '<input name="vehicle" placeholder="For example, 2019 Honda CR-V">' ) +
		field( 'Size', '<select name="size">' + options( [ 'Small car', 'SUV or pickup', 'Large SUV, truck or van' ] ) + '</select>' ) +
		field( 'Service', '<select name="service">' + options( Q.services ) + '</select>' ) +
		field( 'Preferred date', '<input name="date" type="date">' ) +
		field( 'Anything we should know', '<textarea name="message" maxlength="1000" placeholder="Pet hair, stains, odours, paint concerns"></textarea>', 'full' ) +
		'<div class="photos full" role="group" aria-labelledby="q-photos-l">' +
			'<p class="photos-l" id="q-photos-l">Photos of your car <span class="opt">(up to ' + MAX_PHOTOS + ')</span></p>' +
			'<div class="photos-btns">' +
				( touch ? '<button class="btn btn-line btn-sm photo-pick photo-pick--cam" type="button" data-pick="cam">Take a photo</button>' : '' ) +
				'<button class="btn btn-line btn-sm photo-pick photo-pick--lib" type="button" data-pick="lib">Upload photos</button>' +
				( touch ? '<input type="file" accept="image/*" capture="environment" data-input="cam" hidden>' : '' ) +
				'<input type="file" accept="image/*" multiple data-input="lib" hidden>' +
			'</div>' +
			'<ul class="photos-list"></ul>' +
		'</div>' +
		'<div class="hp" aria-hidden="true"><label>Website<input name="website" tabindex="-1" autocomplete="off"></label></div>' +
		'<p class="status" role="status" aria-live="polite"></p>' +
		'<button class="btn btn-gold btn-arrow" type="submit"></button>';
	form.querySelector( 'button[type=submit]' ).textContent = button;
	box.appendChild( form );

	var status = form.querySelector( '.status' );
	var list = form.querySelector( '.photos-list' );
	var photos = [];

	function say( msg, err ) {
		status.className = err ? 'status err' : 'status';
		status.textContent = msg;
	}

	// Marks one field and writes its message. After the first send attempt every edit re-checks the field.
	var tried = false;
	function check( el ) {
		var msg = CHECKS[ el.name ]( el.value.trim() );
		el.setAttribute( 'aria-invalid', msg ? 'true' : 'false' );
		form.querySelector( '#q-' + el.name + '-e' ).textContent = msg;
		return ! msg;
	}
	Object.keys( CHECKS ).forEach( function ( name ) {
		var el = form.elements[ name ];
		[ 'input', 'change' ].forEach( function ( type ) {
			el.addEventListener( type, function () {
				if ( tried ) {
					check( el );
				}
			} );
		} );
	} );

	// Shrink to EDGE on the long side as JPEG. The browser applies the photo's rotation when it decodes it.
	function shrink( file ) {
		return new Promise( function ( resolve, reject ) {
			var url = URL.createObjectURL( file );
			var im = new Image();
			im.onload = function () {
				var s = Math.min( 1, EDGE / Math.max( im.naturalWidth, im.naturalHeight ) );
				var c = document.createElement( 'canvas' );
				c.width = Math.round( im.naturalWidth * s );
				c.height = Math.round( im.naturalHeight * s );
				c.getContext( '2d' ).drawImage( im, 0, 0, c.width, c.height );
				URL.revokeObjectURL( url );
				c.toBlob( function ( b ) { return b ? resolve( b ) : reject(); }, 'image/jpeg', 0.82 );
			};
			im.onerror = function () { URL.revokeObjectURL( url ); reject(); };
			im.src = url;
		} );
	}

	function render() {
		list.innerHTML = '';
		photos.forEach( function ( ph, i ) {
			var li = document.createElement( 'li' );
			var im = document.createElement( 'img' );
			im.src = ph.url;
			im.alt = 'Photo ' + ( i + 1 );
			var x = document.createElement( 'button' );
			x.type = 'button';
			x.className = 'photo-x';
			x.setAttribute( 'aria-label', 'Remove photo ' + ( i + 1 ) );
			x.addEventListener( 'click', function () {
				URL.revokeObjectURL( ph.url );
				photos.splice( i, 1 );
				render();
				say( 'Photo removed. ' + photos.length + ' of ' + MAX_PHOTOS + ' added.' );
				( list.querySelector( '.photo-x' ) || form.querySelector( '.photo-pick:not([disabled])' ) || form ).focus();
			} );
			li.appendChild( im );
			li.appendChild( x );
			list.appendChild( li );
		} );
		form.querySelectorAll( '.photo-pick' ).forEach( function ( b ) { b.disabled = photos.length >= MAX_PHOTOS; } );
	}

	form.querySelectorAll( '.photo-pick' ).forEach( function ( b ) {
		b.addEventListener( 'click', function () { form.querySelector( '[data-input="' + b.dataset.pick + '"]' ).click(); } );
	} );

	form.querySelectorAll( '[data-input]' ).forEach( function ( input ) {
		input.addEventListener( 'change', function () {
			var files = Array.prototype.slice.call( input.files || [] );
			input.value = '';
			var room = MAX_PHOTOS - photos.length;
			var skipped = files.length > room;
			files = files.slice( 0, Math.max( room, 0 ) );
			if ( ! files.length ) {
				return;
			}
			say( 'Adding photos' );
			var bad = 0;
			Promise.all( files.map( function ( f ) {
				return shrink( f ).then( function ( b ) {
					if ( photos.length < MAX_PHOTOS ) {
						photos.push( { blob: b, url: URL.createObjectURL( b ) } );
					}
				}, function () { bad++; } );
			} ) ).then( function () {
				render();
				var msg = photos.length + ' of ' + MAX_PHOTOS + ' photos added.';
				if ( bad ) { msg += ' ' + bad + ( bad > 1 ? ' photos' : ' photo' ) + ' could not be opened. Please choose a JPEG or PNG.'; }
				if ( skipped ) { msg += ' You can send up to ' + MAX_PHOTOS + ' photos.'; }
				say( msg, bad > 0 );
			} );
		} );
	} );
	form.addEventListener( 'submit', function ( e ) {
		e.preventDefault();
		tried = true;
		var bad = Object.keys( CHECKS ).map( function ( name ) { return form.elements[ name ]; } ).filter( function ( el ) { return ! check( el ); } );
		if ( bad.length ) {
			say( 'Please fill in the fields marked in red.', true );
			bad[ 0 ].focus();
			return;
		}
		var data = new FormData( form );
		photos.forEach( function ( ph, i ) { data.append( 'photos[]', ph.blob, 'car-photo-' + ( i + 1 ) + '.jpg' ); } );
		var btn = form.querySelector( 'button[type=submit]' );
		btn.disabled = true;
		say( photos.length ? 'Sending your request and photos' : 'Sending' );
		fetch( Q.url, { method: 'POST', headers: { 'X-WP-Nonce': Q.nonce }, body: data } )
			.then( function ( r ) { return r.json().then( function ( j ) { return { ok: r.ok, j: j }; } ); } )
			.then( function ( res ) {
				if ( ! res.ok ) { throw new Error( res.j && res.j.message ? res.j.message : 'The form could not send. Please call or text us instead.' ); }
				var done = document.createElement( 'div' );
				done.className = 'quote-done';
				done.setAttribute( 'tabindex', '-1' );
				done.innerHTML = '<p class="lead">' + thanks + '</p>';
				form.replaceWith( done );
				done.focus();
			} )
			.catch( function ( err ) {
				btn.disabled = false;
				say( err.message, true );
			} );
	} );
}() );
